import React from 'react';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Podcast from './Podcast';
import PodcastEn from './PodcastEn'

const App = () => {
  return (
    <Router>
      <div className="bg-mainBackground">
        <Routes>
          <Route path="/" element={<Podcast />} />
          <Route path="/en" element={<PodcastEn />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;